import Vue from 'vue'

import { Button, Col, ColorPicker, Dialog, Form, FormItem, Image, Input, InputNumber, Message, MessageBox, Option, Pagination, Radio, RadioGroup, Row, Select, TabPane, Table, TableColumn, Tabs, Tooltip } from 'element-ui'

Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Tooltip)
Vue.use(ColorPicker)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Option)
Vue.use(Radio)
Vue.use(RadioGroup)

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
